import { Component, OnInit } from '@angular/core';

import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';

@Component({
  selector: 'app-Info-frontpage',
  templateUrl: './Info-frontpage.component.html',
  styleUrls: ['./Info-frontpage.component.css'],
  imports: [dialogInputTitleComponent],
})
export class InfoFrontpageComponent implements OnInit {
  constructor() {}

  dialogInputTitleComponent = dialogInputTitleComponent;

  ngOnInit() {}
}
